import { gql } from "@apollo/client";

const GET_PROFILEPIC = gql`
  query GetProfile {
    getProfilePic @client
  }
`;

export default GET_PROFILEPIC;
